import objectFitVideos from '../../../../../../node_modules/object-fit-videos/object-fit-videos.js';

import 'Core/foundation';

$(document).foundation();

import 'Core/cookie-banner';
import 'Core/navigation';
import { PaginationWatcher } from 'Global/listings/pagination/_pagination';
import { FilterWatcher } from 'Global/listings/filters/_filters';
import doLangSwitch from "Global/language-switcher/language-switcher";
import {primaryNavigation} from "./core/primaryNavigation";
import {expandables} from "./core/expandable";

import { LazyPlay } from './video/videoSnippet';

import {backToTop} from "./core/backToTop";

import 'slick-carousel';

import './global/global';
import './search/search';
import './header/header';
import './listing/listing';
import './mediatext/mediatext';
import './facts-figures/facts-figures';
import './promo/promo';
import './promo/promo-grid';
import './footer/footer';
import './listing-paginated-list/listing-paginated-list';
import './promo-quotes-standard/promo-quotes-standard';
import './tabbed-standard/tabbed-standard';

FilterWatcher();
PaginationWatcher();
doLangSwitch();

$(document).ready(function () {
	//if ($pagination.length > 0) {
		//addHash();
	//}

	primaryNavigation();
	expandables();

	LazyPlay();

	objectFitVideos();

	//iframeAutoheight();

	backToTop();

	// const iframeAutoHeight =  $('.js-iframe-autoheight');
	//
	//
	// if (iframeAutoHeight.length > 0) {
	// 	// eslint-disable-next-line
	// 	EurolandToolIntegrationObject.set('nahdiIframe');
	// }


});
//

window.addEventListener('load', () => {

	// triggering this on the load event to cater for the equalizer foundation plugin
	// combined with slow image serving, and the plugin, the wrapper height doesnt get sorted properly
	//$(window).trigger('resize');

});
